import { FrameService } from '@aipb/gulliver/frame/data-access';

import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLinkWithHref } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'aipb-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [MatCardModule, MatButtonModule, TranslocoModule, RouterLinkWithHref]
})
export class NotFoundComponent {
  constructor(private frame: FrameService) {
    this.frame.setStaticRoutes([]);
  }
}
